<template>
  <div class="ca-page">
    <div class="ca-banner">
      <img src="@/assets/image/ca.png" alt="CA证书办理" class="ca-banner-img" />
    </div>
    <div class="ca-content">
      <div class="ca-cards">
        <!-- 企业CA -->
        <div class="ca-card enterprise" @mouseenter="hoverCard = 'enterprise'" @mouseleave="hoverCard = null">
          <div class="card-icon-wrap enterprise-icon-wrap">
            <i class="el-icon-office-building"></i>
          </div>
          <h3 class="card-title">企业CA办理</h3>
          <p class="card-desc">适用于企业用户数字证书的申请与更新，保障企业在电子招投标平台的身份安全</p>
          <el-button class="card-btn enterprise-btn" @click="handleEnterpriseCa">
            <i class="el-icon-right"></i> 开始办理
          </el-button>
        </div>
        <!-- 法人CA -->
        <div class="ca-card legal" @mouseenter="hoverCard = 'legal'" @mouseleave="hoverCard = null">
          <div class="card-icon-wrap legal-icon-wrap">
            <i class="el-icon-user"></i>
          </div>
          <h3 class="card-title">法人CA办理</h3>
          <p class="card-desc">适用于企业法人代理的个人数字证书，实现法人身份的安全认证与授权</p>
          <el-button class="card-btn legal-btn" @click="handleLegalCa">
            <i class="el-icon-right"></i> 开始办理
          </el-button>
        </div>
        <!-- 专家入库 -->
        <div class="ca-card expert" @mouseenter="hoverCard = 'expert'" @mouseleave="hoverCard = null">
          <div class="card-icon-wrap expert-icon-wrap">
            <i class="el-icon-s-custom"></i>
          </div>
          <h3 class="card-title">专家入库</h3>
          <p class="card-desc">成为平台认证专家，享受更多专属服务，参与专业评标工作</p>
          <el-button class="card-btn expert-btn" @click="handleExpertEntry">
            <i class="el-icon-right"></i> 开始办理
          </el-button>
        </div>
      </div>
      <div class="ca-tips">
        <i class="el-icon-info-circle"></i>
        <span>办理前请准备好营业执照、法人身份证等相关材料，如有疑问请联系平台客服</span>
      </div>
    </div>
    <el-dialog :visible.sync="legalDialogVisible" width="25%" :close-on-click-modal="false" custom-class="legal-dialog"
      :show-close="true">
      <div class="legal-dialog-content">
        <el-form ref="legalForm" :model="legalForm" :rules="legalRules" size="small">
          <el-form-item label="法人姓名" prop="name">
            <el-input v-model="legalForm.name" placeholder="请输入法人姓名" />
          </el-form-item>
          <el-form-item label="法人身份证" prop="idCard">
            <el-input v-model="legalForm.idCard" placeholder="请输入身份证号" />
          </el-form-item>
          <el-form-item label="法人手机号" prop="mobile">
            <el-input v-model="legalForm.mobile" placeholder="请输入法人手机号" :maxlength="11"
              @input="legalForm.mobile = legalForm.mobile.replace(/\D/g, '').slice(0, 11)" />
          </el-form-item>

           
          <el-form-item label="公司名称" prop="unitName">
            <el-input v-model="legalForm.unitName" placeholder="请输入公司名称" />
          </el-form-item>
          <el-form-item label="办理方式" prop="cnoPaper">
            <el-radio-group v-model="legalForm.cnoPaper">
              <el-radio :label="0">Ukey证书</el-radio>
              <el-radio :label="1">托管云证书</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div style="color: red; margin-left: 10px;font-size: 15px;">
        <li>*法人CA办理分为托管云单位证书和Ukey证书</li>
        <li>*托管云证书签章需要法人本人扫描二维码进行签章</li>
        <li>*Ukey证书在审核通过后48小时内安排快递发出（节假日除外)</li>
      </div>
      <div slot="footer" class="legal-dialog-footer">
        <el-button class="cancel-btn" @click="closeLegalDialog">取消</el-button>
        <el-button type="primary" :loading="legalLoading" @click="handleExpertBank">
          <i class="el-icon-check"></i> 确认办理
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { expertLegalRegist } from '@/api/modules/base'
// deviceType 0 pc 1 移动
export default {
  name: 'CaHandle',
  data() {
    return {
      hoverCard: null,
      legalDialogVisible: false,
      legalLoading: false,
      legalForm: {
        name: '',
        idCard: '',
        mobile: '',
        cnoPaper: '',
      },
      legalRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
        unitName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleEnterpriseCa() {
      window.open('https://online.bjca.org.cn/v2/#/index/indexNew?channelId=PT1nTjRnak13QVRN', '_blank')
    },
    handleLegalCa() {
      this.legalDialogVisible = true
    },
    handleExpertEntry() {
      window.open('/expertBankLogin', '_blank')
    },
    closeLegalDialog() {
      this.legalDialogVisible = false
      this.$refs.legalForm && this.$refs.legalForm.resetFields()
    },
    async handleExpertBank() {
      console.log(this.legalForm)
      if (this.legalForm.cnoPaper === '') {
        this.$message.error('请选择办理方式')
        return
      }
      this.$refs.legalForm.validate(async valid => {
        if (!valid) return
        this.legalLoading = true
        try {
          const res = await expertLegalRegist({
            deviceType: '0',
            name: this.legalForm.name,
            idCard: this.legalForm.idCard,
            mobile: this.legalForm.mobile,
            cnoPaper: this.legalForm.cnoPaper,
            unitName: this.legalForm.unitName
          })
          if (res.code === 200) {
            window.open(res.data, '_blank')
            this.$message.success('入库申请提交成功')
            this.closeLegalDialog()
          } else {
            this.$message.error(res.msg || '入库失败')
          }
        } catch (e) {
          this.$message.error('请求失败：' + (e.message || '未知错误'))
        } finally {
          this.legalLoading = false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.ca-page {
  min-height: calc(100vh - 120px);
  background: #f0f4f8;
  overflow-x: hidden;
}

// ─── Banner ───────────────────────────────────────────────────────────────────────
.ca-banner {
  width: 100%;
  line-height: 0;
}

.ca-banner-img {
  width: 100%;
  display: block;
  object-fit: cover;
}

// ─── Content ────────────────────────────────────────────────────────────────
.ca-content {
  max-width: 860px;
  margin: 0 auto;
  padding: 40px 24px 60px;
}

.ca-cards {
  display: flex;
  gap: 28px;

  @media (max-width: 640px) {
    flex-direction: column;
  }
}

// ─── Card ───────────────────────────────────────────────────────────────────
.ca-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: #fff;
  border-radius: 16px;
  padding: 36px 28px 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  position: relative;
  overflow: hidden;
  cursor: default;
  box-sizing: border-box;
  min-width: 0;

  &:hover {
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
  }
}

.enterprise::before {
  background: linear-gradient(90deg, #1a6fc4, #42a5f5);
}

.expert::before {
  background: linear-gradient(90deg, #16a34a, #4ade80);
}

.legal::before {
  background: linear-gradient(90deg, #7b2ff7, #a855f7);
}

.card-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  background: linear-gradient(135deg, #ff6b35, #f7931e);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
  letter-spacing: 0.5px;
}

.card-icon-wrap {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;

  i {
    font-size: 28px;
    color: #fff;
  }
}

.enterprise-icon-wrap {
  background: linear-gradient(135deg, #1a6fc4, #42a5f5);
}

.expert-icon-wrap {
  background: linear-gradient(135deg, #16a34a, #4ade80);
}

.legal-icon-wrap {
  background: linear-gradient(135deg, #7b2ff7, #a855f7);
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a2a3a;
  margin: 0 0 10px;
}

.card-desc {
  font-size: 13px;
  color: #7a8999;
  line-height: 1.7;
  margin: 0 0 20px;
  flex: 1;
}

.card-features {
  list-style: none;
  padding: 0;
  margin: 0 0 28px;

  li {
    font-size: 13px;
    color: #4a5f72;
    padding: 5px 0;
    display: flex;
    align-items: center;
    gap: 8px;

    i {
      font-size: 14px;
      font-weight: 700;
    }
  }
}

.enterprise .card-features li i {
  color: #1a6fc4;
}

.expert .card-features li i {
  color: #16a34a;
}

.legal .card-features li i {
  color: #7b2ff7;
}

.card-btn {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  letter-spacing: 0.5px;

  i {
    margin-right: 4px;
  }
}

.enterprise-btn {
  background: linear-gradient(135deg, #1a6fc4, #42a5f5);
  color: #fff;

  &:hover,
  &:focus {
    background: linear-gradient(135deg, #155fa0, #1e8fe0);
    color: #fff;
  }
}

.expert-btn {
  background: linear-gradient(135deg, #16a34a, #4ade80);
  color: #fff;

  &:hover,
  &:focus {
    background: linear-gradient(135deg, #15803d, #22c55e);
    color: #fff;
  }
}

.legal-btn {
  background: linear-gradient(135deg, #7b2ff7, #a855f7);
  color: #fff;

  &:hover,
  &:focus {
    background: linear-gradient(135deg, #6a1fe0, #9333ea);
    color: #fff;
  }
}

// ─── Tips ───────────────────────────────────────────────────────────────────
.ca-tips {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 28px;
  padding: 12px 16px;
  background: #e8f4ff;
  border-radius: 8px;
  color: #4a7cb0;
  font-size: 13px;

  i {
    font-size: 15px;
    flex-shrink: 0;
  }
}
</style>

<style lang="less">
.legal-dialog {
  border-radius: 16px !important;
  overflow: hidden;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 0;
    border-top: 1px solid #f0f0f0;
  }

  .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
    z-index: 10;

    .el-dialog__close {
      color: #fff;
      font-size: 18px;
    }
  }
}

.legal-dialog-content {
  padding: 24px 32px 8px;
}

.legal-dialog-footer {
  display: flex;
  gap: 12px;
  padding: 16px 32px;

  .cancel-btn {
    flex: 1;
    height: 42px;
    border-radius: 8px;
    font-size: 14px;
    color: #7a8999;
    border-color: #dde2e8;
  }

  .confirm-btn {
    flex: 2;
    height: 42px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    background: linear-gradient(135deg, #7b2ff7, #a855f7);
    border: none;

    &:hover {
      background: linear-gradient(135deg, #6a1fe0, #9333ea);
    }
  }
}
</style>
